/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tick': {
    width: 11,
    height: 8,
    viewBox: '0 0 11 8',
    data: '<path pid="0" d="M8.9.006c-.441.184-3.68 3.404-5.463 5.3-.397.11-1.855-1.818-2.205-1.913-.365-.1-1.295 1.063-1.229 1.428.067.366 1.562 2.392 3.455 3.153a.32.32 0 0 0 .268-.007.367.367 0 0 0 .073-.018c.335-.126 6.495-6.25 6.493-6.66C10.29.732 9.105-.08 8.9.006z" _fill="#3a687d" fill-rule="nonzero"/>'
  }
})
